<template>
  <v-autocomplete
      :multiple="multiple"
      prepend-icon="class"
      :items="items"
      :item-text="'Nro'"
      :item-value="'Nro'"
      v-model="item"
      :label="$t('afip.factura.labels.PtoVta')"
      :loading="loading"
      :error="hasInputErrors('PtoVta')"
      :error-messages="getInputErrors('PtoVta')"
      color="secondary"
      item-color="secondary"
      :rules="required"
  ></v-autocomplete>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import AfipProvider from "@/modules/afip/providers/AfipProvider";

export default {
  name: "PuntoVentaCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: [String, Number, Array]
    },
    multiple: {type: Boolean, default: false}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    getPuntosDeVentaSetting(){
      return this.$store.getters.getSettingValue('PuntosDeVenta')
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      AfipProvider.getPuntosVenta().then(r => {


        this.items = r.data.getPuntosVenta

        if(!this.items){
          this.items = this.getPuntosDeVentaSetting
        }

      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

